/**
 * Global recording indicator: fixed pill shown while a block recording is
 * active (started from BulletMenu → "Record audio"), with elapsed time,
 * stop (creates the audio block) and cancel.
 */

import { type Component, createEffect, createSignal, onCleanup, Show } from 'solid-js'
import { Portal } from 'solid-js/web'
import { activeRecording, formatElapsed, stopBlockRecording } from '../audio/recorder'
import { Iconify } from './mini-components'

export const RecordingOverlay: Component = () => {
	const [now, setNow] = createSignal(Date.now())

	createEffect(() => {
		if (!activeRecording()) return
		const interval = setInterval(() => setNow(Date.now()), 500)
		onCleanup(() => clearInterval(interval))
	})

	return (
		<Show when={activeRecording()}>
			{recording => (
				// Portal to body: escapes ancestor stacking contexts that would
				// otherwise paint page content over the fixed pill.
				<Portal>
					<div class='fixed bottom-4 left-1/2 -translate-x-1/2 z-1500 flex items-center gap-3 px-4 py-2 rounded-full bg-red-900 text-white shadow-lg'>
						<div class='i-ph:record-fill' text-red-400 animate-pulse />
						<span font-mono>{formatElapsed(now() - recording().startedAt)}</span>
						<wa-button size='small' variant='brand' onClick={() => void stopBlockRecording()}>
							<Iconify name='stop-fill' slot='start' />
							Save
						</wa-button>
						<button
							class='text-white/70 hover:text-white text-sm underline bg-transparent border-none cursor-pointer'
							onClick={() => void stopBlockRecording(true)}
						>
							Cancel
						</button>
					</div>
				</Portal>
			)}
		</Show>
	)
}
